<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="serverError === null">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item active">
        Redemption Codes
      </li>
    </ol>
  </nav>

  <h2>
    Redemption Code Sets
    <span *ngIf="loadingRedemptionCodeSets" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingRedemptionCodeSets">({{ resultList.count.toLocaleString() }})</span>
  </h2>

  <div class="row">
    <div class="col mb-3 clearfix">
      <select class="custom-select w-auto"
              [(ngModel)]="filters.status"
              (ngModelChange)="this.filtersChangedSubject.next()">
        <option [ngValue]="null">Status: All</option>
        <option *ngFor="let status of Object.values(RedemptionCodeSetStatus)"
                [ngValue]="status">
          Status: {{ getRedemptionCodeSetStatusDisplay(status) }}
        </option>
      </select>

      <a class="btn btn-success float-right" href="#"
         (click)="$event.preventDefault();openCreateRedemptionCodeSetModal();">
        Create Redemption Code Set
      </a>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Name</th>
        <th>Product</th>
        <th>Status</th>
        <th>Expiration Date</th>
        <th># Codes</th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let result of resultList.results"
          style="cursor: pointer"
          routerLink="/redemption-codes/{{ result.id }}">
        <td>{{ result.name }}</td>
        <td>
          {{ getRedemptionCodeSetProductTypeDisplay(result.product_type) }}:
          {{ result.product_name }}
        </td>
        <td [class.text-success]="result.status === RedemptionCodeSetStatus.available"
            [class.text-secondary]="result.status === RedemptionCodeSetStatus.depleted"
            [class.text-danger]="result.status === RedemptionCodeSetStatus.expired">
          {{ getRedemptionCodeSetStatusDisplay(result.status) }}
        </td>
        <td>
          <span *ngIf="result.expiration_date">
            {{ dateStringFromISO8601(result.expiration_date) }}
          </span>
          <span *ngIf="!result.expiration_date" class="text-muted">
            None
          </span>
        </td>
        <td>
          {{ result.num_codes }}
          <ng-container *ngIf="result.status !== RedemptionCodeSetStatus.expired">
            ({{ result.num_codes_available }} available)
          </ng-container>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99" class="text-muted">
          {{ loadingRedemptionCodeSets ? 'Loading...' : 'No redemption code sets' }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeRedemptionCodes" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="floating-alert-container">
    <ng-container *ngIf="modalResult || lastCreatedSet">
      <div class="alert alert-success alert-dismissible" role="alert"
           *ngIf="lastCreatedSet">
        "{{ lastCreatedSet.name }}" created successfully.
        <a routerLink="/redemption-codes/{{ lastCreatedSet.id }}">
          Click here to view.
        </a>
        <button type="button" class="close" (click)="lastCreatedSet = null">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="alert alert-success alert-dismissible" role="alert"
           *ngIf="modalResult.status === CallbackResultStatus.success">
        {{ modalResult.text }}
        <button type="button" class="close" (click)="modalResult = null">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="alert alert-danger alert-dismissible" role="alert"
           *ngIf="modalResult.status === CallbackResultStatus.error">
        {{ modalResult.text }}
        <button type="button" class="close" (click)="modalResult = null">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </ng-container>
  </div>

</div>
